/**
 * Phaser - Effet de phase classique
 * Son "whooshy" caractéristique
 */

import * as Tone from 'tone';

export class Phaser {
    constructor() {
        this.phaser = new Tone.Phaser({
            frequency: 0.5,      // Vitesse de modulation (Hz)
            octaves: 3,          // Plage de sweep
            stages: 10,          // Nombre d'étages (plus = plus prononcé)
            Q: 10,               // Résonance
            baseFrequency: 350,  // Fréquence de base
            wet: 1               // 100% wet pour bus send
        });

        this.input = this.phaser;

        this._frequency = 0.5;
        this._octaves = 3;
        this._q = 10;
        this._mix = 0.3;
        this._isActive = true;

        this._outputGain = new Tone.Gain(this._mix);
        this.phaser.connect(this._outputGain);
        this.output = this._outputGain;
    }

    get frequency() { return this._frequency; }
    get octaves() { return this._octaves; }
    get q() { return this._q; }
    get mix() { return this._mix; }

    setFrequency(hz) {
        this._frequency = hz;
        this.phaser.frequency.value = hz;
    }

    setOctaves(oct) {
        this._octaves = oct;
        this.phaser.octaves = oct;
    }

    setQ(q) {
        this._q = q;
        this.phaser.Q.value = q;
    }

    setMix(mix) {
        this._mix = mix;
        this._outputGain.gain.value = mix;
    }

    connectTo(destination) {
        this.output.connect(destination);
    }

    disconnect() {
        this.output.disconnect();
    }

    /**
     * Active/désactive l'effet (économie CPU)
     * Sets frequency to 0 when inactive to stop LFO modulation
     * @param {boolean} active - true pour activer, false pour désactiver
     */
    setActive(active) {
        if (active === this._isActive) return;
        this._isActive = active;

        if (active) {
            this.phaser.frequency.value = this._frequency;
        } else {
            this.phaser.frequency.value = 0;
        }
    }

    getParams() {
        return {
            frequency: this._frequency,
            octaves: this._octaves,
            q: this._q,
            mix: this._mix
        };
    }

    setParams(params) {
        if (params.frequency !== undefined) this.setFrequency(params.frequency);
        if (params.octaves !== undefined) this.setOctaves(params.octaves);
        if (params.q !== undefined) this.setQ(params.q);
        if (params.mix !== undefined) this.setMix(params.mix);
    }

    dispose() {
        this.phaser.dispose();
        this._outputGain.dispose();
    }
}
